module.exports = __webpack_public_path__ + "static/media/warning.f9b98e14.svg";